import React from 'react';
import { cn } from '../../lib/utils';

const WalletGauge = ({ balance, maxBalance = 100, hourlyRate = 75, className }) => {
  const percentage = Math.min((balance / maxBalance) * 100, 100);
  const amount = balance * hourlyRate;
  
  const getColor = () => {
    if (percentage >= 50) return '#00d4aa';
    if (percentage >= 25) return '#f59e0b';
    return '#ef4444';
  };

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div 
        className="relative h-32 w-32 flex items-center justify-center rounded-full"
        style={{
          background: `conic-gradient(
            from 0deg,
            ${getColor()} ${percentage}%,
            #e2e8f0 ${percentage}%
          )`
        }}
        data-testid="wallet-gauge"
      >
        <div className="h-24 w-24 bg-white rounded-full flex items-center justify-center flex-col shadow-inner">
          <span className="font-mono font-bold text-2xl text-[#1a365d]" data-testid="wallet-hours">
            {balance.toFixed(1)}h
          </span>
          <span className="text-xs text-[#64748b]">disponibles</span>
        </div>
      </div>
      
      <div className="mt-3 text-center">
        <p className="font-mono font-bold text-lg text-[#1a365d]" data-testid="wallet-amount">
          {amount.toFixed(2)}€
        </p>
        <p className="text-xs text-[#64748b]">
          Taux: {hourlyRate}€/h
        </p>
      </div>
      
      {percentage < 25 && (
        <div className="mt-2 text-center">
          <span className="text-xs text-[#f59e0b] font-semibold bg-[#fef3c7] px-2 py-1 rounded-full">
            ⚠️ Crédit faible
          </span>
        </div>
      )}
    </div>
  );
};

export default WalletGauge;
